import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-verify-email-expired',
  templateUrl: './verify-email-expired.component.html',
  styleUrls: ['./verify-email-expired.component.scss']
})
export class VerifyEmailExpiredComponent implements OnInit {

  constructor(
    private navigationService: NavigationService
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.navigationService.navigate(['home']);
    }, 3000);
  }
}
